import {view, css, Button} from '@sail/ui/deprecated';
import {FormattedMessage, defineMessages} from 'react-intl';
import {useCallback} from 'react';
import {useTheme} from '../ThemeProvider';

export type SendUsAnEmailConfirmationProps = {
  useNewDesigns?: boolean;
  onEmailConfirmationClose?: () => void;
};

export const messages = defineMessages({
  title: {
    id: 'conversations_ui.sendUsAnEmailForm.emailConfirmation.title',
    description: 'The aria label applies to the subtitle text in the header',
    defaultMessage: 'Thanks!',
  },
  subtitle: {
    id: 'conversations_ui.sendUsAnEmailForm.emailConfirmation.subtitle',
    description: 'The aria label applies to the subtitle text in the header',
    defaultMessage:
      "We've received your message, and will try to get back to you by email within 24 hours.",
  },
  closeButtonLabel: {
    id: 'conversations_ui.sendUsAnEmailForm.emailConfirmation.closeButton.label',
    description: 'The aria label applies to the subtitle text in the header',
    defaultMessage: 'Close',
  },
});

export function SendUsAnEmailConfirmation({
  useNewDesigns,
  onEmailConfirmationClose,
}: SendUsAnEmailConfirmationProps) {
  const theme = useTheme();

  const onClose = useCallback(() => {
    onEmailConfirmationClose?.();
  }, [onEmailConfirmationClose]);

  if (useNewDesigns) {
    return null;
  }

  return (
    <view.div>
      <view.h2>
        <FormattedMessage {...messages.title} />
      </view.h2>
      <view.p css={{marginBottom: css.value('24px')}}>
        <FormattedMessage {...messages.subtitle} />
      </view.p>
      <Button
        size="large"
        type="secondary"
        css={{
          width: css.value('100%'),
          '&:focus': {
            focusRing: theme.focusVisibleOutline
              ? css.value('none')
              : undefined,
            outline: theme.focusVisibleOutline,
          },
        }}
        onPress={onClose}
        data-testid="email-confirmation-close-button"
      >
        <FormattedMessage {...messages.closeButtonLabel} />
      </Button>
    </view.div>
  );
}
